module.exports = __webpack_public_path__ + "img/logodima.62f4b62c.png";